module.exports = __webpack_public_path__ + "media/assets/images/flags/fr-ff032adbcc6501be9ea48010f3bb6970.svg";